import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";
import { PUBLIC_ROUTES } from "@/src/public/constants/public-routes";

const ContractSignPage = lazy(() => import("@/src/public/pages/contract-sign-page"));
const PaymentSuccessPage = lazy(() => import("@/src/public/pages/payment-success-page"));
const PublicPropertyPage = lazy(() => import("@/src/public/pages/public-property-page"));

export const publicRoutes: RouteObject[] = [
	{ path: PUBLIC_ROUTES.CONTRACT_SIGN, element: <ContractSignPage />, errorElement: <ErrorRouteBoundary /> },
	{ path: PUBLIC_ROUTES.PAYMENT_SUCCESS, element: <PaymentSuccessPage />, errorElement: <ErrorRouteBoundary /> },
	{ path: PUBLIC_ROUTES.PROPERTY, element: <PublicPropertyPage />, errorElement: <ErrorRouteBoundary /> },
];
